<!--
  各个板块标题内容组件
-->

<template>
  <div class="content_section">
    <div class="title">
      <span>{{title}}</span>
    </div>
    <div :class="setMainClass()" :style="mainStyle">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  export default{
    name:'contetnSection',
    props:{
      // 标题文字
      title:{
        type:String,
        default:'标题'
      },
      // 内容部分dom样式
      mainStyle:{
        type:Object
      },
      // 内容所处的位置
      position:{
        type:String,
        default:'left'
      }
    },

    methods:{
      // 通过父组件传来的position判断 返回class名
      setMainClass(){
        return this.position == 'left' ? 'main left_main':'main right_main'
      }
    }
  }
</script>

<style lang="less" scoped>
.content_section{
  .title{
    width: 488px;
    // width:  fit-content;
    height: 72vh *@vh;
    box-sizing: border-box;
    background-image: url('@/assets/img/home_title.png');
    background-size: cover;
    font-family: PMZ;
    position: relative;
    span{
      font-size: 72px;
      color: #fff;
      text-shadow: 0 10vh*@vh 10vh*@vh  #000;
      position: relative;
      top: -20vh * @vh;
      position: absolute;
      left: 110px;
      white-space: nowrap;
    }
  }
  .main{
    width: 856.87px;
    height: 650vh * @vh;
    margin-top: 30vh * @vh;
    margin-bottom: 72vh * @vh;
    background: rgba(0,0,0,0.2);
    border-bottom-style: solid;
    border-width: 1px;
    border-color: rgba(255,255,255,0.5);
    border-bottom-right-radius: 50px;
    border-bottom-left-radius: 50px;
  }
  .left_main{
    border-bottom-left-radius: 0;
  }
  .right_main{
    border-bottom-right-radius: 0;
  }
}
@media screen and (min-width: 3640px),screen and(max-height: 1080) {
  .content_section{
    // width: 244px;
    .title{
      width: 244px;
      height: 36vh *@vh;
      span{
        font-size: 36px;
        top: -10vh * @vh;
        left: 55px;
      }
    }
    .main{
      // width: 856.87px;
      width: 646.87px;
    }
    .left_main{
      border-bottom-left-radius: 0;
    }
    .right_main{
      border-bottom-right-radius: 0;
    }
  }
}
</style>